$(document).ready(function() {
  let accordion = $('.footer details');

  function toggleDetailsOpenAttribute() {
    if ($(window).width() >= 700) {
      accordion.attr('open', 'true');
    } else {
      accordion.removeAttr('open');
    }
  }

  toggleDetailsOpenAttribute();

  $(window).on('resize', function() {
    toggleDetailsOpenAttribute();
  });
});

$(document).ready(function() {
  $(window).on('load scroll', function() {
    const wHeight = $(window).height();
    const wScroll = $(window).scrollTop();
    $(".slideUp-block").each(function() {
      const bPosition = $(this).offset().top;
      if (wScroll > bPosition - wHeight + 200) {
        $(this).addClass("slideUp");
      }
    });
  });
});

$(document).ready(function() {
  $('a[href^="#"].smooth').on("click", function(event) {
    event.preventDefault();

    var target = $(this.getAttribute("href"));
    if (target.length) {
      var headerHeight = $(".shopify-section--header").outerHeight() || 0;
      var stickyBarHeight = $(".product-sticky-bar").outerHeight() || 0;
      var totalOffset = headerHeight + stickyBarHeight;

      $("html, body").animate({
          scrollTop: target.offset().top - totalOffset
        },
        600
      );
    }
  });
});

// ポップアップ
$(document).ready(function() {
  const popupKey = 'popupClosedAt';
  const closedAt = localStorage.getItem(popupKey);

  if (!closedAt) {
    $('.overlay, .aw-popup').addClass('active');
  }

  $('.aw-popup__close, .overlay').on('click', function() {
    $('.overlay, .aw-popup').removeClass('active');
    localStorage.setItem(popupKey, new Date().toISOString());
  });
});
